import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RadioGroup from '@material-ui/core/RadioGroup';
import RadioButton from '~/elements/RadioButton';

export default function RadioButtonsGroup({
  selectedCode,
  name,
  list,
  ariaLabel,
}) {
  const [currentValue, setCurrentValue] = useState('');

  function handleChange(event) {
    const { value, name } = event.target;
    setCurrentValue(value);
    selectedCode(name);
  }

  return (
    <RadioGroup
      aria-label={ariaLabel}
      name={name}
      value={currentValue}
      onChange={event => handleChange(event)}
    >
      {list.map(item => {
        const { code, description } = item;
        return (
          <RadioButton
            inputProps={{
              ariaLabel: description,
            }}
            checked={currentValue === description}
            key={description}
            label={description}
            value={description}
            name={code}
          />
        );
      })}
    </RadioGroup>
  );
}

RadioButtonsGroup.propTypes = {
  list: PropTypes.array.isRequired,
  selectedCode: PropTypes.string,
  name: PropTypes.string,
  ariaLabel: PropTypes.string,
};
